import PropTypes from 'prop-types';
import React from 'react';

import useProductBrand from '../../hooks/use_product_brand';
import useTranslation from '../../hooks/use_translation';
import SectionHeader from '../framework/sections/section-header';
import Trans from '../translation/trans';
import AffiliateBrand from './affiliate_brand';

const AffiliateAbout = ({ product_brand_id }) => {
	const { t } = useTranslation('component_affiliate_about');
	const { items: product_brands } = useProductBrand({
		include_product_brands: [product_brand_id],
	});

	const product_brand = product_brands?.length ? product_brands[0] : null;
	if (!product_brand) return <></>;

	return (
		<div className="row align-items-center affiliate-about">
			<div className="col-md-6">
				<div className="square rounded-4 bg-gray-100 rounded d-flex align-items-center justify-content-center">
					<AffiliateBrand product_brand_id={product_brand_id} size="lg" />
				</div>
			</div>
			<div className="col-md-6 ps-lg-5 mt-3 mt-lg-0">
				<SectionHeader
					headingType="p"
					linkType="group_link"
					page="varumarken"
					product_brand_id={product_brand_id}
					subHeadingType="h3"
					subTitle={t('t1')}
					title={product_brand.product_brand_variant?.title}
				/>
				<Trans defaults={product_brand.product_brand_variant?.excerpt} t={t} />
			</div>
		</div>
	);
};

AffiliateAbout.propTypes = {
	product_brand_id: PropTypes.string.isRequired,
};

export default AffiliateAbout;
